
import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { apiClient as api } from '../../../../api/HttpClient';
import { useUserContext } from '../../../protectedRoute/UserContext';

const BookingOrders: React.FC = () => {
  const [bookings, setBookings] = useState<any>({});
  const [tabIndex, setTabIndex] = useState(0);
  const { state } = useUserContext();
  const { propertyID } = state;

  useEffect(() => {
    // Fetch bookings when a property is selected
    if (propertyID) {
      const fetchBookings = async () => {
        try {
          const client = await api;
          const response = await client.get<any>(`/api/payments/properties/${propertyID}/orders/`);
          setBookings(response);
        } catch (error) {
          console.error('Error fetching bookings:', error);
        }
      };
      fetchBookings();
    }
  }, [propertyID]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const renderBookingCard = (booking: any) => (
    <Box key={booking.id} sx={{ border: '1px solid #ccc', p: 2, my: 2 }}>
      <Typography>Booking Start Date: {booking.checkin}</Typography>
      <Typography>Booking End Date: {booking.checkout}</Typography>
      <Typography>Total Price: {booking.total_price}</Typography>
      <Typography>Guest Name: {booking.guest_name}</Typography>
      <Typography>Guest Phone Number: {booking.guest_phone_number}</Typography>
    </Box>
  );

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Booking Orders</Typography>

      <Tabs value={tabIndex} onChange={handleTabChange}
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: '#1B3A32',
          },
          '& .MuiTab-root': {
            color: '#1B3A32',
            '&.Mui-selected': {
              color: '#1B3A32',
            },
          },
        }}
      >
        <Tab label="Upcoming" />
        <Tab label="Ongoing" />
        <Tab label="Completed" />
        <Tab label="Canceled" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {tabIndex === 0 && bookings.Upcoming?.map(renderBookingCard)}
        {tabIndex === 1 && bookings.Ongoing?.map(renderBookingCard)}
        {tabIndex === 2 && bookings.Completed?.map(renderBookingCard)}
        {tabIndex === 3 && bookings.Cancelled?.map(renderBookingCard)}
      </Box>
    </Box>
  );
};

export default BookingOrders;
